// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"188":"58014027","240":"9df68260","279":"df14ff1a","900":"9706779e"}[chunkId] + ".css";
};